import { EventType } from './event-type.interface';

export const KEYPAD_BUTTON: EventType = {
  name: 'Button',
  description: 'When a keypad button is pressed, released or tapped',
  route: 'buttons/keypads',
  category: 'Buttons',
  icon: 'keypad',
  order: 2,
  whitelist: [
    {
      proxy: 'keypad_proxy',
      events: [5000,5001,5002,5003,5004]
    }
  ]
}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/quickstarts/quickstart-simple/event-types/keypad-button.type.ts